import { IBetOnGamesGame, IBetOnGamesToken } from '../../types/interfaces/Slots/BetOnGames';

import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';

import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({ data }: IConvertGameList<IBetOnGamesGame[]>): ISlotViewItem[] =>
    data.map((item: IBetOnGamesGame) => ({
      id: String(item.code),
      gameId: String(item.code),
      gameName: item.name,
      description: item.name,
      provider: 'betOnGames',
      type: CasinoType.slots,
      routeProvider: 'betOnGames',
      imageUrl: `/images/betongames/${item.img}`,
      tab: ['slotMachines'],
    }));

  convertGameUrl = ({ data }: IGetGameUrl<IBetOnGamesToken, null>) => data.link;
}
export default Converter;
